export default __webpack_public_path__ + "static/media/iPhone-regular.fa5f4d72.png";